import { Record } from "immutable";

const ConnectErrorRecord = Record({
  errorCode: null,
  title: "",
  message: ""
});

export default ConnectErrorRecord;
